module.exports = __webpack_public_path__ + "pc/img/swiper_bg_07.f9938313.jpg";